// Copyright (c) 2026 Interpaste, all rights reserved
// @author: norelock <https://gitlab.com/mvvnlight>

export const ROOT = document.getElementById('player')!

export const DEBUG = process.env.NODE_ENV === 'development'

export const ORIGIN = DEBUG ? location.origin : `${location.protocol}//app.borealise.com`